import { render, staticRenderFns } from "./accountView.vue?vue&type=template&id=00a99e39&"
import script from "./accountView.vue?vue&type=script&lang=js&"
export * from "./accountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports